// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsResidenceWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ValidateAddressWebApiResponseDto } from '../..';

interface ValidateAddressParams {
  city: string;
  state: string;
  zipcode: string;
}

export const CappsResidenceWebApiHandler_validateAddress_Path = '/api/web/renter/v1/residence/validateAddress';

export const CappsResidenceWebApiHandler_validateAddress = (getParams: ValidateAddressParams, client = getClient()) => {
  return httpFrontEndRequest<ValidateAddressParams, never, ValidateAddressWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsResidenceWebApiHandler_validateAddress_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};
